import { Injectable } from '@angular/core';
import { ArboService } from './arbo.service';
import { HttpService} from './http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SourceService {
  private type = 'Source';

  // Cache em memória por accountId
  private _listCache = new Map<string, { data: any; timestamp: number }>();
  private _pendingRequests = new Map<string, Promise<any>>(); // Dedup requests em andamento
  private CACHE_TTL = 5 * 60 * 1000; // 5 minutos

  labels = {
    'feed instagram':'Instagram',
    'feed facebook':'Facebook',
    'feed youtube':'YouTube',
  };
  icons = {
    'feed instagram':'logo-instagram',
    'feed facebook':'logo-facebook',
    'feed youtube':'logo-youtube',
  };
  colors = {
    'feed instagram':'instagram',
    'feed facebook':'facebook',
    'feed youtube':'youtube',
  };

  constructor(
    private arboService: ArboService,
    private httpService:HttpService
  ) { }
  
  create(data,network) {
    return this.httpService.post(`${environment.arboUrl}/Source/oauth`,data)
    // let createSource = {Facebook:this.arboService.create(this.type,data),
    //               Youtube :this.httpService.post(`${environment.arboUrl}/Source/oauth`,data),
    //               Instagram:this.arboService.create(this.type,data)
    //             }[network]
    // return createSource
  }
  get(id)      { return this.arboService.get(this.type,id);      }
  // Aumentado de qtd=10 para qtd=100 para buscar mais sources por página
  list(accountId,page=1,qtd=100) {
    const cacheKey = `${accountId}_${page}_${qtd}`;
    const cached = this._listCache.get(cacheKey);
    if (cached && (Date.now() - cached.timestamp < this.CACHE_TTL)) {
      return Promise.resolve(cached.data);
    }
    // Dedup: se já há uma request em andamento para a mesma chave, reutiliza
    if (this._pendingRequests.has(cacheKey)) {
      return this._pendingRequests.get(cacheKey);
    }
    const request = this.arboService.list(this.type+'/account/'+accountId,page,qtd)
      .then(data => {
        this._listCache.set(cacheKey, { data, timestamp: Date.now() });
        this._pendingRequests.delete(cacheKey);
        return data;
      })
      .catch(err => {
        this._pendingRequests.delete(cacheKey);
        throw err;
      });
    this._pendingRequests.set(cacheKey, request);
    return request;
  }

  invalidateCache() {
    this._listCache.clear();
  }
  update(data) { return this.arboService.update(this.type,data); }
  delete(eid)   { return this.arboService.delete('entity',eid);   }

  getLabel(type){
    return this.labels[type];
  }
  getIcon(type){
    return this.icons[type];
  }
  getColor(type){
    return this.colors[type];
  }

  /**
   * Cria uma nova fonte (Source)
   * @param data Dados da fonte a ser criada
   */
  createSource(data: any) {
    return this.httpService.post(
      `${environment.arboUrl}/Source/`,
      data,
    );
  }

   /**
   * Monta a URL do endpoint /start do BE pra OAuth.
   * Popup deve ser aberto DIRETAMENTE com essa URL — BE responde 302 redirect
   * pro Meta/Google. Sem await depois do window.open → sem Chrome tab throttling
   * → popup navega instantâneo pro Meta/Google.
   */
  buildOAuthStartUrl(network: string, sourceId: number): string {
    const t = encodeURIComponent(this.httpService.key || '');
    return `${environment.arboUrl}/OAuth/${network}/start?sourceId=${sourceId}&t=${t}`;
  }

  /**
   * @deprecated Use buildOAuthStartUrl + window.open diretamente.
   * Mantido pra retrocompat. Faz fetch async pro BE pra obter URL do Meta — sujeito
   * ao bug de Chrome tab throttling quando usado com popup pré-aberto.
   */
  async getAuthUrl(network: string, sourceId: number) {
    const res = await this.httpService.get(
      `${environment.arboUrl}/OAuth/${network}?sourceId=${sourceId}`,
      { withCredentials: true }
    );
    if (!res?.url) {
      throw new Error('URL de autenticação não retornada pelo servidor');
    }
    return res.url;
  }

  /**
   * @deprecated Use buildOAuthStartUrl + window.open.
   */
  async retryOAuth(network: string, sourceId: number) {
    return this.getAuthUrl(network, sourceId);
  }

  /**
   * Gera um avatar placeholder usando DiceBear
   * @param userName Nome do usuário para gerar seed
   * @param network Rede social para escolher o estilo
   * @returns URL do avatar gerado
   */
  generatePlaceholderAvatar(userName: string, network: string): string {
    const avatarStyles = {
      'instagram': 'avataaars',
      'facebook': 'personas', 
      'youtube': 'bottts'
    };
    
    const style = avatarStyles[network?.toLowerCase()] || 'initials';
    return `https://api.dicebear.com/7.x/${style}/svg?seed=${encodeURIComponent(userName)}`;
  }
}

